import { Component, OnInit, OnDestroy } from '@angular/core';

// Others
import { WHAT } from '../../shared/classes';
import Tabulator from 'tabulator-tables';
import { BaseModalComponent } from 'src/app/shared/modals/base-modal/base-modal.component';

// Services

import { NgxSpinnerService } from 'ngx-spinner';
import { AdminService } from 'src/app/services/admin/admin.service';
import { MessagesService } from 'src/app/services/message/messages.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.less']
})
export class TransactionsComponent implements OnInit {
  private table: Tabulator;
  public showYearInputFilter = false;
  public showFilterBtn = false;
  private filterYearVal;

  private filterStateObj = {
    currentFilter: '',
    currentData: [],
    allData: []
  };

  constructor(private load: NgxSpinnerService, private admin: AdminService, private msg: MessagesService, private ngbModel: NgbModal,
    private utils: UtilsService) { }

  ngOnInit() {
    this.load.show();
    this.initTable();
    this.getTransactions();
  }

  // inits the table
  private initTable() {
    this.table = new Tabulator('#transactions', {
      responsiveLayout: 'collapse',
      pagination: 'local',
      paginationSize: 15,
      paginationSizeSelector: true,
      index: 'userid',
      layout: 'fitColumns',
      columns: [
        { title: 'Order Id', field: 'orderid', sorter: 'string' },
        { title: 'Item', field: 'item', sorter: 'string' },
        { title: 'Plan', field: 'plan_type', sorter: 'string' },
        { title: 'Price (RM)', field: 'price', sorter: 'string' },
        { title:'Type',field:'payType',sorter:'string'},
        { title: 'Name', field: 'name', sorter: 'string' },
        {
          title: 'Date', field: 'date', sorter: 'date', sorterParams: {
            format: 'MMMM D YYYY, h:mm:ss A'
          }
        },
      ],
      rowClick: (e, row) => {
        const data = row.getData();
        const newData = {
          from: 'transactions',
          data: data
        };

        // mouse click event
        this.loadModal(newData);
      },
      rowTap: (e, row) => {
        const data = row.getData();
        const newData = {
          from: 'transactions',
          data: data
        };

        // touch screen tap
        this.loadModal(newData);
      }
    });
  }

  // filters table by inputed year
  public filterTableByYear() {
    this.filterTable(this.filterYearVal, 'date');
  }

  // shows filter button when type
  public showFilterButton(year) {
    if (year) {
      this.showFilterBtn = true;
      this.filterYearVal = year;
    } else {
      this.showFilterBtn = false;
    }
  }

  // based on select option - filter items of date
  public selectChange(option) {
    this.table.clearFilter();
    this.table.replaceData(this.filterStateObj.allData);

    switch (option) {
      case 'today':
        const todaysDate = this.utils.returnDate(new Date(), 'simple');
        this.filterTable(todaysDate, 'date');
        this.showYearInputFilter = false;
        break;

      case 'year':
        this.showYearInputFilter = true;
        break;

      default:
        this.table.replaceData(this.filterStateObj.allData);
        this.showYearInputFilter = false;

        break;
    }

    this.setFilterState(option);
  }

  // set the filter state
  private setFilterState(filterType) {
    this.filterStateObj.currentFilter = filterType;
    this.filterStateObj.currentData = this.table.getData(true);
    this.table.replaceData(this.filterStateObj.currentData);
  }

  // filters table
  private filterTable(searchValue, filterByWhat) {
    const filters = [];
    const columns = this.table.getColumns();

    switch (filterByWhat) {
      case 'date':

        this.table.setFilter('date', 'like', searchValue);

        break;

      default:
        columns.forEach(function (column) {
          filters.push({
            field: column.getField(),
            type: 'like',
            value: searchValue,
          });
        });
        this.table.setFilter([filters]);
        break;
    }
  }

  // search table
  public searchTable(searchValue) {
    const filters = [];
    const columns = this.table.getColumns();

    columns.forEach(function (column) {
      filters.push({
        field: column.getField(),
        type: 'like',
        value: searchValue,
      });
    });

    this.table.setFilter([filters]);
  }

  // get users all users
  private getTransactions() {
    this.admin.GET(WHAT.Transactions)
      .then(res => this.success(res))
      .catch(err => this.error(err));
  }

  // open modal and pass user data to it
  private loadModal(data) {
    const userModal = this.ngbModel.open(BaseModalComponent, {
      size: 'lg'
    });

    userModal.componentInstance.data = data;

    // userModal
    userModal.result
      .then((msg) => {
        if (msg.success) {
          return;
        }
      })
      .catch((msg) => {
        console.log(msg);
      });
  }

  // handle success
  private success(res) {
    this.table.addData(res);
    this.filterStateObj.allData = res;
    this.load.hide();
  }

  // handle error
  private error(err) {
    this.load.hide();
    this.msg.error(err);
  }

  public exportData(){
    this.table.download("csv","transaction.csv",{delimiter:","});
 }
}
